if (document.title == "Support Feedback") {
    document.addEventListener('DOMContentLoaded', function () {
        const feedbackForm = document.getElementById('feedbackForm');
        const ratingInputs = document.querySelectorAll('input[name="rating"]');

        let selectedRating = 0;

        ratingInputs.forEach(input => {
            input.addEventListener('change', function () {
                selectedRating = this.value;
            });
        });

        feedbackForm.addEventListener('submit', function (e) {
            e.preventDefault();

            const formData = new FormData(this);
            const data = Object.fromEntries(formData.entries());

            data.rating = selectedRating || 0;
            if (data.rating === 0) {
                frappe.msgprint(__("Please provide a rating"));
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');
            if (id) {
                data.id = id;
            }

            frappe.call({
                method: "campus_erp.api.customer_feedback_form.submit_feedback",
                args: {
                    data: JSON.stringify(data)
                },
                callback: function (r) {
                    if (!r.exc) {
                        frappe.msgprint(__("Feedback submitted successfully"));
                        feedbackForm.reset();
                        selectedRating = 0;
                    } else {
                        frappe.msgprint(__("Error submitting feedback. Please try again."));
                        console.error("Error submitting feedback:", r.exc);
                    }
                }
            });
        });
    });
}
